var _path, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinusCm0063(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2718 1.8335C18.3885 1.8335 20.1668 3.5935 20.1668 6.71933V15.281C20.1668 18.3885 18.3977 20.1668 15.281 20.1668H6.71933C3.5935 20.1668 1.8335 18.3885 1.8335 15.281V6.71933C1.8335 3.5935 3.5935 1.8335 6.71933 1.8335H15.2718ZM10.991 6.88433C10.5693 6.88433 10.2302 7.2235 10.2302 7.64516V10.2302H7.636C7.43433 10.2302 7.24183 10.3127 7.09516 10.4502C6.95766 10.5968 6.87516 10.7884 6.87516 10.991C6.87516 11.4127 7.21433 11.7518 7.636 11.761H10.2302V14.3552C10.2302 14.7768 10.5693 15.116 10.991 15.116C11.4127 15.116 11.7518 14.7768 11.7518 14.3552V11.761H14.3552C14.7768 11.7518 15.116 11.4127 15.116 10.991C15.116 10.5693 14.7768 10.2302 14.3552 10.2302H11.7518V7.64516C11.7518 7.2235 11.4127 6.88433 10.991 6.88433Z",
    fill: "#E7E6FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.0833,
    height: 11,
    transform: "matrix(1 0 0 -1 6.41675 16.5)",
    fill: "#E7E6FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.41675,
    y: 10.0835,
    width: 9.16667,
    height: 1.83333,
    rx: 0.916667,
    fill: "#605BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCm0063);
export default __webpack_public_path__ + "static/media/Minus_cm0063.35ba978055d42c8b8879d244f99cdd13.svg";
export { ForwardRef as ReactComponent };